import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../apiConfig';
import { UserServiceData } from '../../data';
import { BaseResponse, RegisterIdentityUserDTO, CreateSharedServiceUserDTO, user } from '../../models';
import { UtilityService } from '../shared-services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends UserServiceData {
  performUserAction(data: any): Observable<any> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.auth.useraction,
      data
    )
  }
  registerUser(user: RegisterIdentityUserDTO): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.auth.register,
      user
    )
  }
  updateUser(user: RegisterIdentityUserDTO, id: any): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.auth.update,
      user,
      id
    )
  }
  extendPasswordExpiry(user: RegisterIdentityUserDTO, id: any): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.auth.extendPasswordExpiry,
      user,
      id
    )
  }
  getAllUsers(id?: any, isActive: any = true, isDeleted: any = false, isSalesAgentRequest: any = false, isEnterpriseSimRequest: any = false): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.admin.getAllUsers,
      null,
      null,
      "post",
      {
        id: id?? '',
        isActive: isActive == null ? '' : isActive,
        isDeleted: isDeleted == null ? '' : isDeleted,
        isSalesAgentRequest : isSalesAgentRequest == null ? '' : isSalesAgentRequest,
        isEnterpriseSimRequest: isEnterpriseSimRequest == null ? '' : isEnterpriseSimRequest
      }
    )
  }

  getUsersByCustomerId(customerId: number, isActive?: any, isDeleted?: any): Observable<BaseResponse<any>> {
    const payload: any = { customerId: customerId ?? 0 };
    if (isActive !== null && isActive !== undefined) {
      payload.isActive = Boolean(isActive);
    }
    if (isDeleted !== null && isDeleted !== undefined) {
      payload.isDeleted = Boolean(isDeleted);
    }

    return this.utitlitySer.postPut<any>(
      ApiConfig.selfcare.getUsersByCustomerId,
      payload,
      null,
      "post"
    )
  }

  createSharedServiceUser(user: CreateSharedServiceUserDTO): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.selfcare.createSharedServiceUser,
      user,
      null,
      "post"
    )
  }
  
  getMonthlyUsersCount(data: any): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.admin.getMonthlyUsersCount,
      data,
    )
  }

  getTotalUserCount(): Observable<BaseResponse<any>> {
    return this.utitlitySer.postPut<any>(
      ApiConfig.admin.getTotalUserCount,
      null,
    )
  }
  
  getRoles(): Observable<any> {
    throw new Error('Method not implemented.');
  }
  addRoles(): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRoles(): Observable<any> {
    throw new Error('Method not implemented.');
  }
  getUsersRoles(): Observable<any> {
    throw new Error('Method not implemented.');
  }
  assignRoles(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  constructor(private utitlitySer: UtilityService) {
    super();
  }
}
